<template>
      <div class="titolo-card">
          <h1>Gestione consulenze</h1>
          <h3>Qui troverai tutti le consulenze effettuate e da effettuare.</h3>
        </div>


      <!-- Bottone per aprire il modale
      <button @click="showModal = true" class="create-user-button">
        Crea Consulenza
      </button>

      <div v-if="showModal" class="modal">
        <div class="modal-content">
          <span class="close" @click="closeModal">&times;</span>
          <h2>Crea Consulenza</h2>
          <form @submit.prevent="addConsulenza">
            <label for="categoriaConsulenza">Tipo Consulenza:</label>
            <select id="categoriaConsulenza" v-model="newConsulenza.categoriaConsulenza">
              <option value="">Seleziona tipo</option>
              <option value="tecnica">Tecnica</option>
              <option value="alimentazione">Alimentazione</option>
            </select>

            <label for="numeroConsulenze">Quante Consulenze:</label>
            <select id="numeroConsulenze" v-model.number="newConsulenza.numeroConsulenze">
              <option value="">Seleziona numero</option>
              <option v-for="num in [1,2,3,4,5,6]" :key="num" :value="num">{{ num }}</option>
            </select>

            <button type="submit">Salva Consulenza</button>
          </form>
        </div>
      </div>
 -->
      <!-- Consulenze (derivate dagli step "consulenza" dei percorsi) -->
      <p class="consulenze-note">
        Qui trovi le stesse consulenze che sono in "Percorsi" e sono create in automatico con l'ordine.
      </p>
      <section class="consulenze-box card">
        <button class="card-head" @click="toggleConsulenze">
          <div class="head-left">
            <div class="title">Consulenze {{ consulenzeDone }}/{{ consulenzeTotal }}</div>
            <div class="sub muted">
              {{ consulenzeRows.length }} step consulenza totali
            </div>
          </div>
          <div class="head-right">
            <span class="material-icons">
              {{ consulenzeOpen ? 'expand_less' : 'expand_more' }}
            </span>
          </div>
        </button>

        <div v-if="consulenzeOpen" class="card-body">
          <div class="consulenze-table-wrap">
            <table class="consulenze-table">
              <thead>
                <tr>
                  <th>Programma</th>
                  <th>Tipo</th>
                  <th>Status</th>
                  <th>Scadenza</th>
                  <th class="consulenze-actions-col">Azioni</th>
                </tr>
              </thead>
              <tbody>
                <tr
                  v-for="row in consulenzeRows"
                  :key="row.rowId"
                  :class="{
                    'consulenze-row--locked': isPercorsoLocked(row.percorso),
                    'consulenze-row--expired': isPercorsoExpired(row)
                  }"
                >
                  <td class="consulenze-summary-cell consulenze-summary-cell--program">
                    <div class="mono" style="font-weight:600">{{ row.percorsoTitle || 'Programma' }}</div>
                    <small class="muted">
                      {{ row.productName || '—' }}
                      <span v-if="row.sequenceIndex"> · #{{ row.sequenceIndex }}/{{ row.sequenceTotal || 1 }}</span>
                    </small>
                  </td>

                  <td class="consulenze-summary-cell">
                    <span class="consulenza-pill" :class="consulenzaTypeClass(row.consulenzaType)">
                      {{ row.consulenzaType || '—' }}
                    </span>
                  </td>

                  <td class="consulenze-summary-cell">
                    <div class="consulenze-status-stack">
                      <span class="consulenza-pill" :class="consulenzaStatusClass(row.consulenzaStatus)">
                        {{ normalizeConsulenzaStatus(row.consulenzaStatus) }}
                      </span>
                      <small class="muted">
                        <template v-if="row.doneAt">Effettuata {{ formatDateOnly(row.doneAt) }}</template>
                        <template v-else-if="normalizeConsulenzaStatus(row.consulenzaStatus) === 'Scalata' && row.scalataAt">Scalata {{ formatDateOnly(row.scalataAt) }}</template>
                        <template v-else-if="row.plannedAt">Prevista {{ formatDateOnly(row.plannedAt) }}</template>
                        <template v-else>Nessuna data impostata</template>
                      </small>
                    </div>
                  </td>

                  <td class="consulenze-summary-cell">
                    <div v-if="row.expireAt" class="date-cell">
                      <span class="date-cell__date">{{ formatDateOnly(row.expireAt) }}</span>
                      <span v-if="isPercorsoExpired(row)" class="expiry-badge expiry-badge--expired">
                        Scaduto
                      </span>
                    </div>
                    <span v-else>—</span>
                  </td>

                  <td class="consulenze-summary-cell consulenze-summary-cell--actions">
                    <button
                      type="button"
                      class="btn ghost consulenze-detail-btn staff-button-neutral"
                      @click="openConsulenzaDetail(row)"
                    >
                      Dettagli
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </section>

      <Teleport to="body">
        <div
          v-if="activeConsulenzaRow"
          class="modal"
          @click.self="closeConsulenzaDetail"
        >
          <div class="modal-content modal-content--consulenza-detail">
            <div class="modal-header">
              <div class="modal-title-area">
                <h2 class="modal-title">Dettagli consulenza</h2>
                <p class="consulenza-detail-subtitle">
                  {{ activeConsulenzaRow.percorsoTitle || 'Programma' }}
                  <span v-if="activeConsulenzaRow.sequenceIndex">
                    · #{{ activeConsulenzaRow.sequenceIndex }}/{{ activeConsulenzaRow.sequenceTotal || 1 }}
                  </span>
                </p>
              </div>
              <div class="modal-header-actions">
                <span class="consulenza-pill" :class="consulenzaStatusClass(activeConsulenzaRow.consulenzaStatus)">
                  {{ normalizeConsulenzaStatus(activeConsulenzaRow.consulenzaStatus) }}
                </span>
                <button type="button" class="icon-btn grey staff-button-neutral" @click="closeConsulenzaDetail" aria-label="Chiudi">
                  <span class="material-icons">close</span>
                </button>
              </div>
            </div>

            <div class="consulenza-detail-body">
              <div class="consulenza-detail-top">
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Programma</span>
                  <strong>{{ activeConsulenzaRow.percorsoTitle || 'Programma' }}</strong>
                  <small>{{ activeConsulenzaRow.productName || '—' }}</small>
                </div>
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Scadenza</span>
                  <strong>{{ activeConsulenzaRow.expireAt ? formatDateOnly(activeConsulenzaRow.expireAt) : '—' }}</strong>
                  <small v-if="isPercorsoExpired(activeConsulenzaRow)">Programma segnato come scaduto</small>
                </div>
                <div class="consulenza-detail-summary-card">
                  <span class="consulenza-detail-summary-label">Professionista</span>
                  <strong>{{ activeConsulenzaRow.TrainerNome || 'Non assegnato' }}</strong>
                </div>
              </div>

              <div class="consulenza-detail-grid">
                <label class="q-field">
                  <span class="q-label">Tipo</span>
                  <select
                    :value="activeConsulenzaRow.consulenzaType || ''"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'consulenzaType', $event.target.value)"
                  >
                    <option value="" disabled>— Seleziona —</option>
                    <option value="Nutrizionale">Nutrizionale</option>
                    <option value="Tecnica">Tecnica</option>
                  </select>
                </label>

                <label class="q-field">
                  <span class="q-label">Status</span>
                  <select
                    :value="activeConsulenzaRow.consulenzaStatus || 'Da fare'"
                    @change="onConsulenzaStatusChangeByKey(activeConsulenzaRow.percorso, 'consulenza', $event.target.value, activeConsulenzaRow.realIndex)"
                  >
                    <option>Da fare</option>
                    <option>Contattata</option>
                    <option>Prenotata</option>
                    <option>Rifiutata</option>
                    <option>Fatta</option>
                    <option>Scalata</option>
                  </select>
                </label>

                <label class="q-field">
                  <span class="q-label">Data prevista</span>
                  <input
                    type="date"
                    :value="formatInputDate(activeConsulenzaRow.plannedAt)"
                    @change="updateConsulenzaPlannedAt(activeConsulenzaRow, $event.target.value)"
                  />
                  <button
                    type="button"
                    class="link-btn staff-button-cancel"
                    @click="updateConsulenzaPlannedAt(activeConsulenzaRow, '')"
                    :disabled="!activeConsulenzaRow.plannedAt"
                  >
                    Rimuovi data
                  </button>
                </label>

                <label class="q-field">
                  <span class="q-label">Data effettuata</span>
                  <input
                    type="date"
                    :value="formatInputDate(activeConsulenzaRow.doneAt)"
                    @change="updateConsulenzaDate(activeConsulenzaRow, 'doneAt', $event.target.value)"
                  />
                </label>

                <label class="q-field">
                  <span class="q-label">Professionista</span>
                  <input
                    type="text"
                    :value="activeConsulenzaRow.TrainerNome || ''"
                    placeholder="Professionista"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'TrainerNome', $event.target.value)"
                  />
                </label>

                <label class="q-field q-field--wide">
                  <span class="q-label">Note</span>
                  <textarea
                    class="consulenza-detail-note"
                    :value="activeConsulenzaRow.staffNote || ''"
                    placeholder="Note interne"
                    @change="updateConsulenzaField(activeConsulenzaRow, 'staffNote', $event.target.value)"
                  />
                </label>

                <div class="q-field q-field--wide">
                  <span class="q-label">Stato programma</span>
                  <button
                    type="button"
                    class="expire-toggle-button"
                    :class="{ 'expire-toggle-button--active': isPercorsoExpired(activeConsulenzaRow) }"
                    :title="isPercorsoExpired(activeConsulenzaRow) ? 'Rimuovi scaduto' : 'Segna scaduto'"
                    :disabled="isExpireToggleBusy('percorso', activeConsulenzaRow.percorsoId)"
                    @click="togglePercorsoExpired(activeConsulenzaRow)"
                  >
                    <span class="material-icons" aria-hidden="true">
                      {{ isPercorsoExpired(activeConsulenzaRow) ? 'remove_circle' : 'schedule' }}
                    </span>
                    {{ isPercorsoExpired(activeConsulenzaRow) ? 'Rimuovi scaduto' : 'Segna scaduto' }}
                  </button>
                </div>

                <div class="q-field q-field--wide">
                  <span class="q-label">Sposta consulenza</span>
                  <div class="consulenza-detail-move">
                    <select
                      class="select"
                      v-model="consulenzaMoveTarget[activeConsulenzaRow.rowId]"
                      :disabled="!!movingConsulenza[activeConsulenzaRow.rowId]"
                    >
                      <option value="" disabled>— Seleziona programma —</option>
                      <option
                        v-for="opt in consulenzaMoveOptions"
                        :key="opt.id"
                        :value="opt.id"
                      >
                        {{ opt.label }}
                      </option>
                    </select>
                    <button
                      type="button"
                      class="btn move-btn staff-button-positive"
                      @click="moveConsulenza(activeConsulenzaRow)"
                      :disabled="
                        !!movingConsulenza[activeConsulenzaRow.rowId] ||
                        !consulenzaMoveTarget[activeConsulenzaRow.rowId] ||
                        consulenzaMoveTarget[activeConsulenzaRow.rowId] === activeConsulenzaRow.percorsoId
                      "
                    >
                      {{ movingConsulenza[activeConsulenzaRow.rowId] ? 'Spostamento…' : 'Sposta' }}
                    </button>
                  </div>
                </div>
              </div>
            </div>

            <div class="modal-footer">
              <button class="action-button2 consulenza-detail-footer-btn staff-button-neutral" @click="closeConsulenzaDetail">Chiudi</button>
              <button
                v-if="canDeleteConsulenza"
                type="button"
                class="create-user-button consulenza-detail-delete consulenza-detail-footer-btn staff-button-danger"
                @click="deleteConsulenza(activeConsulenzaRow)"
                :disabled="!!deletingConsulenza[activeConsulenzaRow.rowId]"
              >
                {{ deletingConsulenza[activeConsulenzaRow.rowId] ? 'Eliminazione…' : 'Elimina consulenza' }}
              </button>
            </div>
          </div>
        </div>
      </Teleport>

      <div
        v-if="hasDetachedConsulenze"
        class="detached-consulenze-alert"
        role="alert"
      >
        <span class="material-icons" aria-hidden="true">info</span>
        <div>
          <strong>Consulenze senza percorso.</strong>
          Questo utente ha {{ detachedConsulenzeCount }} consulenze slegate dai programmi principali.
          Puoi gestirle dalla tabella qui sopra.
        </div>
      </div>

      <!-- Tabella: visualizza il documento e, sotto, le righe per ciascun slot -->
      <div class="consulenze-container">
        <div class="titolo-card">
          <h1>Consulenze storiche</h1>
          <p class="muted">
            Sono quelle consulenze che abbiamo creato in precedenza, slegate dagli ordini.
          </p>
        </div>
        <table>
          <thead>
            <tr>
              <th>Tipo</th>
              <th>Data Creazione</th>
              <th>Data Effettuata</th>
              <th>Status</th>
              <th>Professionista</th>
              <th>Note</th>
              <th>Azioni</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="consulenza in consulenze" :key="consulenza.id">
              <!-- Riga intestazione del documento -->
              <tr
                class="header-row"
                :class="{ 'header-row--expired': isStoricoConsulenzaExpired(consulenza) }"
              >
                <td colspan="7">
                  <div class="storico-header-content">
                    <span class="storico-header-title">
                      {{ consulenza.categoriaConsulenza ? consulenza.categoriaConsulenza.toUpperCase() : '' }}
                    </span>
                    <div class="storico-header-actions">
                      <button
                        type="button"
                        class="expire-toggle-button"
                        :class="{ 'expire-toggle-button--active': isStoricoConsulenzaExpired(consulenza) }"
                        :title="isStoricoConsulenzaExpired(consulenza) ? 'Rimuovi scaduto' : 'Segna scaduto'"
                        :disabled="isExpireToggleBusy('consulenza', consulenza.id)"
                        @click.stop="toggleStoricoExpired(consulenza)"
                      >
                        <span class="material-icons" aria-hidden="true">
                          {{ isStoricoConsulenzaExpired(consulenza) ? 'remove_circle' : 'schedule' }}
                        </span>
                        {{ isStoricoConsulenzaExpired(consulenza) ? 'Rimuovi scaduto' : 'Segna scaduto' }}
                      </button>
                      <span v-if="isStoricoConsulenzaExpired(consulenza)" class="expiry-badge expiry-badge--expired">
                        Scaduto
                      </span>
                    </div>
                  </div>
                </td>
              </tr>
              <!-- Righe per ogni slot -->
              <tr
                v-for="(slot, index) in consulenza.slots"
                :key="index"
                :class="{ 'storico-row--expired': isStoricoConsulenzaExpired(consulenza) }"
              >
                <td></td>
                <td>{{ formatDate(slot.dataCreazioneslot) }}</td>
                <td>
                  <input
                    type="date"
                    :value="formatInputDate(slot.dataEffettuata)"
                    @change="updateSlotField($event, consulenza, index, 'dataEffettuata')" />
                </td>
                <td>
                  <select
                    :value="normalizeSlotStatus(slot.status)"
                    @change="updateSlotStatus($event, consulenza, index)"
                  >
                    <option value="da_fare">Da fare</option>
                    <option value="programmata">Programmata</option>
                    <option value="fatta">Fatta</option>
                  </select>
                </td>
                <td>
                  <input
                    type="text"
                    :value="slot.TrainerNome"
                    @change="updateSlotField($event, consulenza, index, 'TrainerNome')" />
                </td>
                <td>
                  <input
                    type="text"
                    :value="slot.note"
                    @change="updateSlotField($event, consulenza, index, 'note')" />
                </td>
                <td class="right">
                  <button
                    type="button"
                    class="icon-btn danger staff-button-danger"
                    @click="deleteStoricoConsulenzaSlot(consulenza, index)"
                    :disabled="!!deletingStoricoSlot[storicoSlotRowKey(consulenza.id, index)]"
                    title="Elimina riga"
                    aria-label="Elimina riga"
                  >
                    <span class="material-icons">
                      {{ deletingStoricoSlot[storicoSlotRowKey(consulenza.id, index)] ? 'hourglass_top' : 'delete' }}
                    </span>
                  </button>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
</template>

<script>
import { ref, watch, computed, onBeforeUnmount } from 'vue';
import {
  getFirestore,
  collection,
  addDoc,
  query,
  onSnapshot,
  updateDoc,
  deleteDoc,
  doc,
  where,
  getDoc,
  writeBatch
} from 'firebase/firestore';
import { getAuth, onAuthStateChanged } from 'firebase/auth';
import { normalizeProgramTitle } from '@/lib/percorsoStepNotifications';

const ADD_PROGRAM_PRIV_UID = 'HpMiFyBZnwX6EUf6VR9iCsHkqo82';
const ADD_PROGRAM_PRIV_EMAIL = 'valeriobianconi@gmail.com';

export default {
  name: "ConsulenzeComponent",
  props: {
    // uid dell'utente target per cui si crea la consulenza
    userId: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const db = getFirestore();
    const auth = getAuth();
    const showModal = ref(false);
    const consulenze = ref([]);
    const percorsi = ref([]);
    const consulenzeOpen = ref(false);
    const consulenzaMoveTarget = ref({});
    const movingConsulenza = ref({});
    const deletingConsulenza = ref({});
    const deletingStoricoSlot = ref({});
    const expireToggleLoading = ref({});
    const canAddProgram = ref(false);

    let authUnsub = null;
    let consulenzeUnsub = null;
    let percorsiUnsub = null;

    // Dati del form per la nuova consulenza
    const newConsulenza = ref({
      categoriaConsulenza: '',
      numeroConsulenze: null,
    });

    const updateAddProgramPermission = (user) => {
      if (!user) {
        canAddProgram.value = false;
        return;
      }
      const email = (user.email || '').toLowerCase();
      canAddProgram.value =
        user.uid === ADD_PROGRAM_PRIV_UID || email === ADD_PROGRAM_PRIV_EMAIL.toLowerCase();
    };

    const initAuthWatcher = () => {
      updateAddProgramPermission(auth.currentUser);
      authUnsub = onAuthStateChanged(auth, updateAddProgramPermission);
    };

    const canDeleteConsulenza = computed(() => canAddProgram.value);

    const notify = (message, type = 'info') => {
      if (type === 'error' || type === 'success') {
        alert(message);
        return;
      }
      console.info(message);
    };

    initAuthWatcher();

    const closeModal = () => {
      showModal.value = false;
      newConsulenza.value = { categoriaConsulenza: '', numeroConsulenze: null };
    };

    // Funzione per generare un id random
    const generateRandomId = () => {
      // Se disponibile, utilizza crypto.randomUUID(), altrimenti fallback a Math.random
      return crypto.randomUUID ? crypto.randomUUID() : Math.random().toString(36).substr(2, 9);
    };

    // Crea un unico documento con un array di slot (uno per ciascuna consulenza)
    const addConsulenza = async () => {
      if (!newConsulenza.value.categoriaConsulenza || !newConsulenza.value.numeroConsulenze) {
        alert("Completa tutti i campi richiesti.");
        return;
      }
      const num = newConsulenza.value.numeroConsulenze;
      const slots = [];
      for (let i = 0; i < num; i++) {
        slots.push({
          dataCreazioneslot: new Date().toISOString(),
          dataEffettuata: null,
          TrainerNome: '',
          note: ''
        });
      }
      try {
        await addDoc(collection(db, "consulenze"), {
          // uid: utente target per cui si crea la consulenza
          uid: props.userId,
          // creatorUid: amministratore che crea lo slot (ottenuto da firebase auth)
          creatorUid: auth.currentUser.uid,
          categoriaConsulenza: newConsulenza.value.categoriaConsulenza,
          numeroConsulenze: num,
          slots: slots,
          // idConsulenza generato random
          idConsulenza: generateRandomId()
        });
        alert("Consulenza creata con successo!");
        closeModal();
      } catch (error) {
        console.error("Errore nel salvataggio della consulenza:", error);
        alert("Errore nel salvataggio della consulenza.");
      }
    };

    // Recupera le consulenze dal db filtrando per uid
    const fetchConsulenze = () => {
      if (consulenzeUnsub) {
        consulenzeUnsub();
      }
      const consulenzeQuery = query(
        collection(db, "consulenze"),
        where("uid", "==", props.userId)
      );
      consulenzeUnsub = onSnapshot(consulenzeQuery, (querySnapshot) => {
        consulenze.value = querySnapshot.docs.map(doc => ({
          id: doc.id,
          ...doc.data()
        }));
      });
    };

    const percorsiVisibili = computed(() => (percorsi.value || []).filter(p => !p.consulenzeOnly));
    const toggleConsulenze = () => { consulenzeOpen.value = !consulenzeOpen.value; };

    const toComparableString = (value) => {
      if (!value) return '';
      if (typeof value === 'string') return value;
      if (value instanceof Date) return value.toISOString();
      if (typeof value?.toDate === 'function') {
        try { return value.toDate().toISOString(); }
        catch { return ''; }
      }
      return String(value);
    };

    const renderProgramTitle = (rawTitle) => normalizeProgramTitle(rawTitle);

    const parseSequenceIndex = (value) => {
      if (typeof value === 'number') {
        return Number.isFinite(value) ? value : null;
      }
      if (typeof value === 'string') {
        const match = value.match(/\d+/);
        return match ? Number(match[0]) : null;
      }
      return null;
    };
    const getSequenceIndex = (percorso) => parseSequenceIndex(percorso?.sequenceIndex);

    const stepKeyFromName = (name = '') => {
      const n = (name || '').toLowerCase();
      if (n.includes('check') || n.includes('scadenza')) return 'check_finale';
      if (n.includes('questionario')) return 'questionario';
      if (n.includes('consegna')) return 'consegna';
      if (n.includes('consulenza')) return 'consulenza';
      return null;
    };

    const normalizeConsulenzaStatus = (val) => {
      const s = String(val || '').trim().toLowerCase();
      if (s === 'contattata' || s === 'contattato') return 'Contattata';
      if (s === 'prenotata' || s === 'prenotato') return 'Prenotata';
      if (s === 'rifiutata' || s === 'rifiutato') return 'Rifiutata';
      if (s === 'fatta' || s === 'fatto') return 'Fatta';
      if (s === 'scalata' || s === 'scalato') return 'Scalata';
      return 'Da fare';
    };
    const isConsulenzaStatusDone = (status) => {
      const normalized = normalizeConsulenzaStatus(status);
      return normalized === 'Fatta' || normalized === 'Rifiutata' || normalized === 'Scalata';
    };

    const isBlockingStepForSequence = (step) => {
      const name = (step?.name || '').toLowerCase();
      if (!name) return true;
      if (name.includes('feedback')) return false;
      return true;
    };
    const isStepEffectivelyDone = (step) => {
      if (!step) return false;
      const name = (step?.name || '').toLowerCase();
      if (name.includes('consulenza') && isConsulenzaStatusDone(step?.consulenzaStatus)) {
        return true;
      }
      return !!step?.done;
    };
    const isRealCheckFinaleStep = (step = {}) => {
      const name = (step?.name || '').toLowerCase();
      const isCheck = name.includes('check') || name.includes('scadenza');
      if (!isCheck) return false;
      return !step?.convertedFromQuestionario;
    };
    const hasCheckFinaleDone = (steps = []) =>
      (Array.isArray(steps) ? steps : []).some(
        (step) => isRealCheckFinaleStep(step) && isStepEffectivelyDone(step)
      );
    const blockingStepsOnly = (steps = []) =>
      (Array.isArray(steps) ? steps : []).filter(isBlockingStepForSequence);
    const isPercorsoFullyCompleted = (percorso) => {
      const steps = Array.isArray(percorso?.steps) ? percorso.steps : [];
      if (!steps.length) return false;
      if (hasCheckFinaleDone(steps)) return true;
      const blockingSteps = blockingStepsOnly(steps);
      if (!blockingSteps.length) return true;
      return blockingSteps.every(isStepEffectivelyDone);
    };
    const isPercorsoHistoryLocked = (percorso) => !!(percorso?.historyLocked);
    const hasSequenceUnlockOverride = (percorso) => percorso?.sequenceUnlockOverride === true;
    const hasCompletedUnlockOverride = (percorso) => percorso?.completedUnlockOverride === true;
    const isPercorsoCompleteForLocking = (percorso) =>
      isPercorsoFullyCompleted(percorso) || isPercorsoHistoryLocked(percorso);

    const sequentialLocks = computed(() => {
      const locks = {};
      const groups = new Map();
      for (const percorso of percorsiVisibili.value || []) {
        if (!percorso?.id) continue;
        const gid = percorso.sequenceGroupId || percorso.id;
        const arr = groups.get(gid) || [];
        arr.push(percorso);
        groups.set(gid, arr);
      }
      const sortBySequence = (a, b) => {
        const ix = Number(a?.sequenceIndex) || 0;
        const iy = Number(b?.sequenceIndex) || 0;
        if (ix !== iy) return ix - iy;
        const ax = toComparableString(a?.plannedStartAt || a?.createdAt);
        const ay = toComparableString(b?.plannedStartAt || b?.createdAt);
        return ax.localeCompare(ay);
      };
      for (const list of groups.values()) {
        if (!list.length) continue;
        const sorted = [...list].sort(sortBySequence);
        const gatingActive = sorted.length > 1 || Number(sorted[0]?.sequenceTotal) > 1;
        let blockNext = false;
        sorted.forEach((percorso) => {
          if (!gatingActive) {
            locks[percorso.id] = false;
            return;
          }
          const override = hasSequenceUnlockOverride(percorso);
          locks[percorso.id] = blockNext && !override;
          const isComplete = isPercorsoCompleteForLocking(percorso);
          if (!isComplete) {
            blockNext = true;
          } else {
            blockNext = false;
          }
        });
      }
      return locks;
    });
    const previousGroupLocks = computed(() => {
      const locks = {};
      const groups = new Map();
      const ordered = [];

      for (const percorso of percorsiVisibili.value || []) {
        if (!percorso?.id) continue;
        const gid = percorso.sequenceGroupId || percorso.id;
        const anchor = toComparableString(percorso.plannedStartAt || percorso.createdAt);
        let group = groups.get(gid);
        if (!group) {
          group = { id: gid, anchor, percorsi: [] };
          groups.set(gid, group);
          ordered.push(group);
        } else if (anchor && (!group.anchor || anchor < group.anchor)) {
          group.anchor = anchor;
        }
        group.percorsi.push(percorso);
      }

      ordered.sort((a, b) => (a.anchor || '').localeCompare(b.anchor || ''));

      let blockFollowing = false;
      for (const group of ordered) {
        const list = group.percorsi || [];
        const groupCompleted = list.every(
          (p) => hasSequenceUnlockOverride(p) || isPercorsoCompleteForLocking(p)
        );

        list.forEach((percorso) => {
          locks[percorso.id] = blockFollowing && !hasSequenceUnlockOverride(percorso);
        });

        if (!groupCompleted) {
          blockFollowing = true;
        }
      }

      return locks;
    });
    const isPercorsoSequentiallyLocked = (percorso) =>
      !!(percorso && sequentialLocks.value[percorso.id]);
    const isPercorsoBlockedByPreviousGroup = (percorso) =>
      !!(percorso && previousGroupLocks.value[percorso.id]);
    const percorsoLockReason = (percorso) => {
      if (isPercorsoHistoryLocked(percorso)) return 'history';
      if (isPercorsoFullyCompleted(percorso) && !hasCompletedUnlockOverride(percorso)) return 'completed';
      if (isPercorsoBlockedByPreviousGroup(percorso)) return 'previous_group';
      if (isPercorsoSequentiallyLocked(percorso)) return 'sequence';
      return null;
    };
    const isPercorsoLocked = (percorso) => percorsoLockReason(percorso) !== null;

    const normalizeConsulenzaType = (raw) => {
      const value = String(raw || '').toLowerCase();
      if (value.includes('nutriz')) return 'nutrizionale';
      if (value.includes('tecnic')) return 'tecnica';
      return '';
    };
    const isFirstProgramInSequence = (percorso) => {
      const idx = getSequenceIndex(percorso);
      const total = Number(percorso?.sequenceTotal);
      if (idx === 1) return true;
      if (idx == null && (!Number.isFinite(total) || total <= 1)) return true;
      return false;
    };
    const STEP_ORDER = {
      questionario: 3,
      consegna: 6,
      consulenza: 10,
      check_finale: 12
    };
    const stepOrderForPercorso = (percorso, key, consulenzaType, step) => {
      const normalizedType = normalizeConsulenzaType(consulenzaType);
      if (isFirstProgramInSequence(percorso)) {
        if (key === 'questionario') return 1;
        if (key === 'check_finale' && step?.convertedFromQuestionario) return 1;
        if (key === 'consulenza' && normalizedType === 'nutrizionale') return 2;
        if (key === 'consegna') return 3;
        if (key === 'consulenza' && normalizedType === 'tecnica') return 4;
        if (key === 'check_finale') return 5;
      }
      let order = STEP_ORDER[key] ?? 99;
      if (key === 'consulenza' && normalizedType === 'nutrizionale') {
        order = 2;
      }
      return order;
    };

    const consulenzeRows = computed(() => {
      const rows = [];
      for (const p of (percorsi.value || [])) {
        const steps = Array.isArray(p.steps) ? p.steps : [];
        steps.forEach((s, idx) => {
          const key =
            (s?.name || '').toLowerCase().includes('questionario') ? 'questionario' :
            (s?.name || '').toLowerCase().includes('consegna') ? 'consegna' :
            ((s?.name || '').toLowerCase().includes('check') || (s?.name || '').toLowerCase().includes('scadenza')) ? 'check_finale' :
            (s?.name || '').toLowerCase().includes('consulenza') ? 'consulenza' : null;

          if (key !== 'consulenza') return;

          rows.push({
            rowId: `${p.id}__${idx}`,
            percorsoId: p.id,
            percorso: p,
            realIndex: idx,
            percorsoTitle: renderProgramTitle(p.title),
            productName: p.productName || null,
            sequenceIndex: p.sequenceIndex || 1,
            sequenceTotal: p.sequenceTotal || 1,
            expireAt: p.expireAt || null,
            plannedAt: s.plannedAt || null,
            doneAt: s.doneAt || null,
            scalataAt: s.scalataAt || null,
            staffNote: s.staffNote || '',
            consulenzaStatus: s.consulenzaStatus || 'Da fare',
            consulenzaType: s.consulenzaType || '',
            TrainerNome: s.TrainerNome || '',
          });
        });
      }
      return rows;
    });

    const activeConsulenzaRowId = ref('');
    const activeConsulenzaRow = computed(() =>
      consulenzeRows.value.find((row) => row.rowId === activeConsulenzaRowId.value) || null
    );
    const openConsulenzaDetail = (row) => {
      activeConsulenzaRowId.value = row?.rowId || '';
    };
    const closeConsulenzaDetail = () => {
      activeConsulenzaRowId.value = '';
    };
    const updatePercorsoLocal = (updatedPercorso) => {
      percorsi.value = percorsi.value.map((p) => (p.id === updatedPercorso.id ? updatedPercorso : p));
    };
    const patchPercorsoStepLocal = (percorsoId, stepIndex, buildNextStep) => {
      const currentPercorso = (percorsi.value || []).find((p) => p.id === percorsoId);
      if (!currentPercorso) return null;

      const currentSteps = Array.isArray(currentPercorso.steps) ? currentPercorso.steps : [];
      if (stepIndex < 0 || stepIndex >= currentSteps.length) return null;

      const steps = currentSteps.map((step) => (
        step && typeof step === 'object' ? { ...step } : step
      ));
      const prevStep = steps[stepIndex] || {};
      const nextStep = typeof buildNextStep === 'function'
        ? buildNextStep(prevStep)
        : { ...prevStep, ...(buildNextStep || {}) };

      steps[stepIndex] = nextStep;
      const nextPercorso = { ...currentPercorso, steps };
      updatePercorsoLocal(nextPercorso);
      return { previousPercorso: currentPercorso, nextPercorso, steps, prevStep, nextStep };
    };
    const updateLegacyConsulenzaLocal = (consulenzaId, buildNextConsulenza) => {
      const currentConsulenza = (consulenze.value || []).find((item) => item.id === consulenzaId);
      if (!currentConsulenza) return null;

      const nextConsulenza = typeof buildNextConsulenza === 'function'
        ? buildNextConsulenza(currentConsulenza)
        : { ...currentConsulenza, ...(buildNextConsulenza || {}) };

      consulenze.value = consulenze.value.map((item) => (
        item.id === consulenzaId ? nextConsulenza : item
      ));
      return { previousConsulenza: currentConsulenza, nextConsulenza };
    };
    const consulenzaStatusClass = (status) => {
      const normalized = normalizeConsulenzaStatus(status);
      if (normalized === 'Fatta') return 'consulenza-pill--done';
      if (normalized === 'Rifiutata') return 'consulenza-pill--rejected';
      if (normalized === 'Contattata') return 'consulenza-pill--contacted';
      if (normalized === 'Prenotata') return 'consulenza-pill--scheduled';
      if (normalized === 'Scalata') return 'consulenza-pill--escalated';
      return 'consulenza-pill--todo';
    };
    const consulenzaTypeClass = (type) => {
      const normalized = String(type || '').trim().toLowerCase();
      if (normalized === 'tecnica') return 'consulenza-pill--technical';
      if (normalized === 'nutrizionale') return 'consulenza-pill--nutritional';
      return 'consulenza-pill--neutral';
    };

    const consulenzaMoveOptions = computed(() =>
      (percorsiVisibili.value || []).map(p => ({
        id: p.id,
        label: `${renderProgramTitle(p.title)}${p.sequenceTotal ? ` · Prog. ${p.sequenceIndex}/${p.sequenceTotal}` : ''}`
      }))
    );

    const detachedConsulenzeCount = computed(() =>
      consulenzeRows.value.filter(row => row.percorso?.consulenzeOnly).length
    );
    const hasDetachedConsulenze = computed(() => detachedConsulenzeCount.value > 0);

    const consulenzeTotal = computed(() => consulenzeRows.value.length);
    const consulenzeDone = computed(() =>
      consulenzeRows.value.filter(r => isConsulenzaStatusDone(r?.consulenzaStatus) || !!r.doneAt).length
    );

    const fetchPercorsi = () => {
      if (percorsiUnsub) {
        percorsiUnsub();
      }
      const qPerc = query(collection(db, 'percorsi'), where('uid', '==', props.userId));
      percorsiUnsub = onSnapshot(qPerc, (qs) => {
        const rows = qs.docs.map(d => ({ id: d.id, ...d.data() }));

        const groups = new Map();
        const groupMeta = new Map();
        for (const p of rows) {
          const gid = p.sequenceGroupId || p.id;
          const arr = groups.get(gid) || [];
          arr.push(p);
          groups.set(gid, arr);

          const anchorThis = toComparableString(p.plannedStartAt || p.createdAt);
          const meta = groupMeta.get(gid) || { anchor: anchorThis || '', productName: p.productName || null };
          if (!meta.anchor || (anchorThis && anchorThis < meta.anchor)) meta.anchor = anchorThis;
          if (!meta.productName && p.productName) meta.productName = p.productName;
          groupMeta.set(gid, meta);
        }

        const groupOrder = Array.from(groups.keys()).sort((a, b) => {
          const aa = toComparableString(groupMeta.get(a)?.anchor);
          const bb = toComparableString(groupMeta.get(b)?.anchor);
          return bb.localeCompare(aa);
        });

        const sorted = [];
        for (const gid of groupOrder) {
          const list = groups.get(gid) || [];
          list.sort((x, y) => {
            const ix = Number(x.sequenceIndex) || 0;
            const iy = Number(y.sequenceIndex) || 0;
            if (ix !== iy) return ix - iy;
            const dx = toComparableString(x.plannedStartAt || x.createdAt);
            const dy = toComparableString(y.plannedStartAt || y.createdAt);
            return dx.localeCompare(dy);
          });
          sorted.push(...list);
        }

        percorsi.value = sorted;
      });
    };

    const dateFormatter = new Intl.DateTimeFormat('it-IT', {
      day: '2-digit', month: '2-digit', year: 'numeric'
    });

    const toDateSafe = (value) => {
      if (value === undefined || value === null) return null;
      if (typeof value?.toDate === 'function') {
        try {
          const converted = value.toDate();
          return converted instanceof Date && !Number.isNaN(converted.getTime()) ? converted : null;
        } catch {
          return null;
        }
      }
      if (value instanceof Date) {
        return Number.isNaN(value.getTime()) ? null : value;
      }
      if (typeof value === 'string' || typeof value === 'number') {
        const parsed = new Date(value);
        return Number.isNaN(parsed.getTime()) ? null : parsed;
      }
      return null;
    };

    // Funzione per formattare la data (dd/mm/yyyy)
    const formatDate = (value) => {
      const date = toDateSafe(value);
      return date ? dateFormatter.format(date) : '';
    };

    const formatDateOnly = (value) => formatDate(value);

    // Formatta la data per l'input type="date" (yyyy-mm-dd)
    const formatInputDate = (value) => {
      if (!value) return '';
      const date = toDateSafe(value);
      if (!date) return '';
      const year = date.getUTCFullYear();
      const month = String(date.getUTCMonth() + 1).padStart(2, '0');
      const day = String(date.getUTCDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    };

    const expiryMonthsByNumeroConsulenze = (numeroConsulenze) => {
      const total = Number(numeroConsulenze);
      if (!Number.isFinite(total) || total <= 0) return 0;
      if (total === 5 || total === 6) return 9;
      if (total === 3 || total === 4) return 6;
      if (total === 2) return 3;
      return 0;
    };

    const getConsulenzaCreatedAt = (consulenza) => {
      const slots = Array.isArray(consulenza?.slots) ? consulenza.slots : [];
      const orderedDates = slots
        .map((slot) => toDateSafe(slot?.dataCreazioneslot))
        .filter(Boolean)
        .sort((a, b) => a.getTime() - b.getTime());
      return orderedDates[0] || null;
    };

    const isStoricoConsulenzaExpired = (consulenza) => {
      if (!consulenza) return false;
      if (consulenza.scadutoManuale === false) return false;
      if (consulenza.scadutoManuale === true) return true;

      const months = expiryMonthsByNumeroConsulenze(consulenza.numeroConsulenze);
      if (!months) return false;

      const createdAt = getConsulenzaCreatedAt(consulenza);
      if (!createdAt) return false;

      const expiryDate = new Date(createdAt);
      expiryDate.setMonth(expiryDate.getMonth() + months);
      return Date.now() >= expiryDate.getTime();
    };

    const isPercorsoExpired = (row) => {
      if (row?.percorso?.scadutoManuale === false) return false;
      if (row?.percorso?.scadutoManuale === true) return true;

      const date = toDateSafe(row?.expireAt);
      if (!date) return false;
      return Date.now() >= date.getTime();
    };

    const expireToggleKey = (type, id) => `${type || 'generic'}:${id || ''}`;
    const isExpireToggleBusy = (type, id) => Boolean(expireToggleLoading.value[expireToggleKey(type, id)]);
    const setExpireToggleBusy = (type, id, active) => {
      const key = expireToggleKey(type, id);
      const next = { ...expireToggleLoading.value };
      if (active) next[key] = true;
      else delete next[key];
      expireToggleLoading.value = next;
    };

    const patchPercorsoLocal = (percorsoId, patch) => {
      if (!percorsoId) return;
      percorsi.value = (percorsi.value || []).map((item) => {
        if (item.id !== percorsoId) return item;
        return { ...item, ...patch };
      });
    };

    const patchConsulenzaLocal = (consulenzaId, patch) => {
      if (!consulenzaId) return;
      consulenze.value = (consulenze.value || []).map((item) => {
        if (item.id !== consulenzaId) return item;
        return { ...item, ...patch };
      });
    };

    const togglePercorsoExpired = async (row) => {
      const percorsoId = row?.percorsoId;
      if (!percorsoId) return;
      if (isExpireToggleBusy('percorso', percorsoId)) return;

      const nextValue = isPercorsoExpired(row) ? false : true;
      const updatedAt = new Date().toISOString();
      setExpireToggleBusy('percorso', percorsoId, true);

      try {
        await updateDoc(doc(db, 'percorsi', percorsoId), {
          scadutoManuale: nextValue,
          scadutoManualeUpdatedAt: updatedAt,
        });
        patchPercorsoLocal(percorsoId, {
          scadutoManuale: nextValue,
          scadutoManualeUpdatedAt: updatedAt,
        });
      } catch (error) {
        console.error('Errore aggiornando lo stato scaduto del programma:', error);
        notify('Errore aggiornando lo stato scaduto del programma.', 'error');
      } finally {
        setExpireToggleBusy('percorso', percorsoId, false);
      }
    };

    const toggleStoricoExpired = async (consulenza) => {
      const consulenzaId = consulenza?.id;
      if (!consulenzaId) return;
      if (isExpireToggleBusy('consulenza', consulenzaId)) return;

      const nextValue = isStoricoConsulenzaExpired(consulenza) ? false : true;
      const updatedAt = new Date().toISOString();
      setExpireToggleBusy('consulenza', consulenzaId, true);

      try {
        await updateDoc(doc(db, 'consulenze', consulenzaId), {
          scadutoManuale: nextValue,
          scadutoManualeUpdatedAt: updatedAt,
        });
        patchConsulenzaLocal(consulenzaId, {
          scadutoManuale: nextValue,
          scadutoManualeUpdatedAt: updatedAt,
        });
      } catch (error) {
        console.error('Errore aggiornando lo stato scaduto della consulenza:', error);
        notify('Errore aggiornando lo stato scaduto della consulenza.', 'error');
      } finally {
        setExpireToggleBusy('consulenza', consulenzaId, false);
      }
    };

    async function updateConsulenzaField(row, field, value) {
      const patch = {};
      if (field === 'consulenzaType') {
        const v = String(value || '').trim();
        patch.consulenzaType = (v === 'Tecnica' || v === 'Nutrizionale') ? v : null;
      } else if (field === 'staffNote') patch.staffNote = (value || '').trim();
      else if (field === 'TrainerNome') patch.TrainerNome = (value || '').trim();
      else if (field === 'consulenzaStatus') patch.consulenzaStatus = value || 'Da fare';
      else return;

      const localUpdate = patchPercorsoStepLocal(
        row.percorsoId,
        row.realIndex,
        (prev) => ({ ...prev, ...patch })
      );
      if (!localUpdate) return;

      try {
        await updateDoc(doc(db, 'percorsi', row.percorsoId), { steps: localUpdate.steps });
      } catch (error) {
        updatePercorsoLocal(localUpdate.previousPercorso);
        console.error('updateConsulenzaField error:', error);
        notify('Errore nell\'aggiornamento della consulenza.', 'error');
      }
    }

    async function updateConsulenzaDate(row, field, dateStr) {
      if (field !== 'doneAt') return;
      const localUpdate = patchPercorsoStepLocal(row.percorsoId, row.realIndex, (prev) => {
        const next = { ...prev };
        if (dateStr) {
          const iso = new Date(`${dateStr}T00:00:00.000Z`).toISOString();
          next.doneAt = iso;
          next.done = true;
          next.consulenzaStatus = 'Fatta';
        } else {
          next.doneAt = null;
          next.done = false;
          if (next.consulenzaStatus === 'Fatta') next.consulenzaStatus = 'Da fare';
        }
        return next;
      });
      if (!localUpdate) return;

      try {
        await updateDoc(doc(db, 'percorsi', row.percorsoId), { steps: localUpdate.steps });
      } catch (error) {
        updatePercorsoLocal(localUpdate.previousPercorso);
        console.error('updateConsulenzaDate error:', error);
        notify('Errore nell\'aggiornamento della consulenza.', 'error');
      }
    }

    async function updateConsulenzaPlannedAt(row, dateStr) {
      let plannedAt = null;
      if (dateStr) {
        const parsed = new Date(`${dateStr}T00:00:00.000Z`);
        if (Number.isNaN(parsed.getTime())) return;
        plannedAt = parsed.toISOString();
      }

      const localUpdate = patchPercorsoStepLocal(
        row.percorsoId,
        row.realIndex,
        (prev) => ({ ...prev, plannedAt })
      );
      if (!localUpdate) return;

      try {
        await updateDoc(doc(db, 'percorsi', row.percorsoId), { steps: localUpdate.steps });
      } catch (error) {
        updatePercorsoLocal(localUpdate.previousPercorso);
        console.error('updateConsulenzaPlannedAt error:', error);
        notify('Errore nell\'aggiornamento della consulenza.', 'error');
      }
    }

    async function moveConsulenza(row) {
      if (!row?.percorsoId) return;
      const targetId = consulenzaMoveTarget.value[row.rowId];
      if (!targetId) { notify('Seleziona il programma di destinazione.', 'error'); return; }
      if (targetId === row.percorsoId) { notify('Scegli un programma diverso da quello corrente.', 'error'); return; }

      const targetPercorso = (percorsi.value || []).find(p => p.id === targetId);
      if (!targetPercorso) { notify('Programma di destinazione non trovato.', 'error'); return; }

      movingConsulenza.value = { ...movingConsulenza.value, [row.rowId]: true };
      try {
        const sourceRef = doc(db, 'percorsi', row.percorsoId);
        const targetRef = doc(db, 'percorsi', targetId);
        const [sourceSnap, targetSnap] = await Promise.all([getDoc(sourceRef), getDoc(targetRef)]);
        if (!sourceSnap.exists() || !targetSnap.exists()) {
          notify('Impossibile recuperare i programmi selezionati.', 'error');
          return;
        }

        const sourceData = sourceSnap.data() || {};
        const targetData = targetSnap.data() || {};
        const sourceSteps = Array.isArray(sourceData.steps) ? [...sourceData.steps] : [];
        const targetSteps = Array.isArray(targetData.steps) ? [...targetData.steps] : [];

        let sourceIndex = Number.isInteger(row.realIndex) ? row.realIndex : -1;
        if (
          sourceIndex < 0 ||
          sourceIndex >= sourceSteps.length ||
          stepKeyFromName(sourceSteps[sourceIndex]?.name) !== 'consulenza'
        ) {
          sourceIndex = sourceSteps.findIndex((s) =>
            stepKeyFromName(s?.name) === 'consulenza'
            && toComparableString(s?.plannedAt) === toComparableString(row.plannedAt)
            && (s?.consulenzaType || '') === (row.consulenzaType || '')
          );
        }
        if (sourceIndex < 0 || sourceIndex >= sourceSteps.length) {
          notify('Step consulenza non trovato (riprova).', 'error');
          return;
        }

        const step = sourceSteps[sourceIndex];
        const stepKey = stepKeyFromName(step?.name);
        if (stepKey !== 'consulenza') {
          notify('Solo le consulenze possono essere spostate.', 'error');
          return;
        }

        const movedStep = { ...step, plannedAt: null };
        sourceSteps.splice(sourceIndex, 1);

        const targetPercorsoWithId = { id: targetSnap.id, ...targetData };
        const orderToInsert = stepOrderForPercorso(targetPercorsoWithId, stepKey, movedStep.consulenzaType, movedStep);
        let insertIndex = targetSteps.length;
        for (let i = 0; i < targetSteps.length; i += 1) {
          const tk = stepKeyFromName(targetSteps[i]?.name);
          const o = stepOrderForPercorso(targetPercorsoWithId, tk, targetSteps[i]?.consulenzaType, targetSteps[i]);
          if (o > orderToInsert) { insertIndex = i; break; }
        }
        targetSteps.splice(insertIndex, 0, movedStep);

        const batch = writeBatch(db);
        batch.update(sourceRef, { steps: sourceSteps });
        batch.update(targetRef, { steps: targetSteps });
        await batch.commit();

        consulenzaMoveTarget.value = { ...consulenzaMoveTarget.value, [row.rowId]: '' };
        closeConsulenzaDetail();
        notify('Consulenza spostata nel programma selezionato.', 'success');
      } catch (error) {
        console.error('moveConsulenza error', error);
        notify('Errore nello spostamento della consulenza.', 'error');
      } finally {
        const next = { ...movingConsulenza.value };
        delete next[row.rowId];
        movingConsulenza.value = next;
      }
    }

    const setDeletingConsulenza = (rowId, active) => {
      const next = { ...deletingConsulenza.value };
      if (active) next[rowId] = true;
      else delete next[rowId];
      deletingConsulenza.value = next;
    };
    const storicoSlotRowKey = (consulenzaId, slotIndex) => `${consulenzaId || ''}:${slotIndex}`;
    const setDeletingStoricoSlot = (slotKey, active) => {
      const next = { ...deletingStoricoSlot.value };
      if (active) next[slotKey] = true;
      else delete next[slotKey];
      deletingStoricoSlot.value = next;
    };

    const deleteConsulenza = async (row) => {
      if (!row?.percorsoId || !row?.rowId) return;
      if (!canDeleteConsulenza.value) {
        notify('Non hai i permessi per eliminare consulenze.', 'error');
        return;
      }
      if (deletingConsulenza.value[row.rowId]) return;
      if (typeof window !== 'undefined' && !window.confirm('Eliminare questa consulenza?')) return;

      setDeletingConsulenza(row.rowId, true);
      try {
        const percRef = doc(db, 'percorsi', row.percorsoId);
        const snap = await getDoc(percRef);
        if (!snap.exists()) {
          notify('Programma non trovato.', 'error');
          return;
        }
        const data = snap.data() || {};
        const steps = Array.isArray(data.steps) ? [...data.steps] : [];

        let sourceIndex = Number.isInteger(row.realIndex) ? row.realIndex : -1;
        if (
          sourceIndex < 0 ||
          sourceIndex >= steps.length ||
          stepKeyFromName(steps[sourceIndex]?.name) !== 'consulenza'
        ) {
          sourceIndex = steps.findIndex((s) =>
            stepKeyFromName(s?.name) === 'consulenza'
            && toComparableString(s?.plannedAt) === toComparableString(row.plannedAt)
            && (s?.consulenzaType || '') === (row.consulenzaType || '')
            && toComparableString(s?.doneAt) === toComparableString(row.doneAt)
          );
        }
        if (sourceIndex < 0 || sourceIndex >= steps.length) {
          notify('Consulenza non trovata.', 'error');
          return;
        }

        steps.splice(sourceIndex, 1);
        await updateDoc(percRef, { steps });
        closeConsulenzaDetail();
        notify('Consulenza eliminata.', 'success');
      } catch (error) {
        console.error('deleteConsulenza error', error);
        notify('Errore nella cancellazione della consulenza.', 'error');
      } finally {
        setDeletingConsulenza(row.rowId, false);
      }
    };

    const VALID_CONSULENZA = new Set(['Da fare', 'Contattata', 'Prenotata', 'Rifiutata', 'Fatta', 'Scalata']);
    const onConsulenzaStatusChangeByKey = async (percorso, stepKey, newStatus, stepIndex) => {
      if ((stepKey || '') !== 'consulenza') return;
      const idx = Number.isInteger(stepIndex)
        ? Number(stepIndex)
        : (percorso?.steps || []).findIndex(s =>
            (s?.name || '').toLowerCase().includes('consulenza')
          );
      if (idx < 0) return;

      const status = normalizeConsulenzaStatus(newStatus);
      if (!VALID_CONSULENZA.has(status)) return;
      const nowIso = new Date().toISOString();

      const localUpdate = patchPercorsoStepLocal(percorso.id, idx, (prev) => {
        const isDone = isConsulenzaStatusDone(status);
        const nextScalataAt = status === 'Scalata'
          ? (prev.scalataAt || nowIso)
          : (prev.scalataAt || null);
        return {
          ...prev,
          consulenzaStatus: status,
          done: isDone,
          doneAt: status === 'Fatta' ? (prev.doneAt || nowIso) : null,
          scalataAt: nextScalataAt,
        };
      });
      if (!localUpdate) return;

      try {
        await updateDoc(doc(db, 'percorsi', percorso.id), { steps: localUpdate.steps });
      } catch (error) {
        updatePercorsoLocal(localUpdate.previousPercorso);
        console.error('onConsulenzaStatusChangeByKey error:', error);
        notify('Errore nell\'aggiornamento dello status consulenza.', 'error');
      }
    };

    // Funzione generica per aggiornare un campo specifico di uno slot
    const updateSlotField = async (event, consulenza, slotIndex, field) => {
      const newValue = event.target.value;
      const updatedSlots = [...consulenza.slots];
      updatedSlots[slotIndex][field] = newValue;
      const localUpdate = updateLegacyConsulenzaLocal(consulenza.id, (current) => {
        const slots = Array.isArray(current.slots)
          ? current.slots.map((slot) => (slot && typeof slot === 'object' ? { ...slot } : slot))
          : [];
        slots[slotIndex] = { ...(slots[slotIndex] || {}), [field]: newValue };
        return { ...current, slots };
      });
      try {
        await updateDoc(doc(db, "consulenze", consulenza.id), {
          slots: updatedSlots
        });
      } catch (error) {
        if (localUpdate?.previousConsulenza) {
          updateLegacyConsulenzaLocal(consulenza.id, localUpdate.previousConsulenza);
        }
        console.error(`Errore aggiornando il campo ${field} dello slot:`, error);
        alert("Errore nell'aggiornamento del campo.");
      }
    };

    const normalizeSlotStatus = (value) => {
      const raw = String(value || '').trim().toLowerCase();
      if (raw === 'fatta' || raw === 'fatto') return 'fatta';
      if (raw === 'programmata' || raw === 'prenotata' || raw === 'prenotato') return 'programmata';
      if (raw === 'da fare' || raw === 'da_fare' || raw === 'da-fare') return 'da_fare';
      return 'da_fare';
    };

    const updateSlotStatus = async (event, consulenza, slotIndex) => {
      const status = normalizeSlotStatus(event.target.value);
      const updatedSlots = [...consulenza.slots];
      updatedSlots[slotIndex] = { ...updatedSlots[slotIndex], status };
      const localUpdate = updateLegacyConsulenzaLocal(consulenza.id, (current) => {
        const slots = Array.isArray(current.slots)
          ? current.slots.map((slot) => (slot && typeof slot === 'object' ? { ...slot } : slot))
          : [];
        slots[slotIndex] = { ...(slots[slotIndex] || {}), status };
        return { ...current, slots };
      });
      try {
        await updateDoc(doc(db, "consulenze", consulenza.id), {
          slots: updatedSlots
        });
      } catch (error) {
        if (localUpdate?.previousConsulenza) {
          updateLegacyConsulenzaLocal(consulenza.id, localUpdate.previousConsulenza);
        }
        console.error("Errore aggiornando lo status dello slot:", error);
        alert("Errore nell'aggiornamento dello status.");
      }
    };
    const deleteStoricoConsulenzaSlot = async (consulenza, slotIndex) => {
      if (!consulenza?.id) return;

      const slotKey = storicoSlotRowKey(consulenza.id, slotIndex);
      if (deletingStoricoSlot.value[slotKey]) return;
      if (typeof window !== 'undefined' && !window.confirm('Eliminare questa riga consulenza?')) return;

      setDeletingStoricoSlot(slotKey, true);
      try {
        const slots = Array.isArray(consulenza.slots) ? [...consulenza.slots] : [];
        if (slotIndex < 0 || slotIndex >= slots.length) {
          notify('Riga non trovata.', 'error');
          return;
        }

        slots.splice(slotIndex, 1);
        const consulenzaRef = doc(db, "consulenze", consulenza.id);
        if (!slots.length) {
          await deleteDoc(consulenzaRef);
          notify('Consulenza eliminata.', 'success');
          return;
        }

        await updateDoc(consulenzaRef, { slots });
        notify('Riga consulenza eliminata.', 'success');
      } catch (error) {
        console.error("deleteStoricoConsulenzaSlot error:", error);
        notify("Errore nella cancellazione della riga.", 'error');
      } finally {
        setDeletingStoricoSlot(slotKey, false);
      }
    };

    watch(() => props.userId, (newUserId) => {
      closeConsulenzaDetail();
      if (newUserId) {
        fetchConsulenze();
        fetchPercorsi();
      }
    }, { immediate: true });

    onBeforeUnmount(() => {
      if (consulenzeUnsub) {
        consulenzeUnsub();
        consulenzeUnsub = null;
      }
      if (percorsiUnsub) {
        percorsiUnsub();
        percorsiUnsub = null;
      }
      if (authUnsub) {
        authUnsub();
        authUnsub = null;
      }
    });

    return {
      showModal,
      newConsulenza,
      addConsulenza,
      closeModal,
      consulenze,
      consulenzeOpen,
      toggleConsulenze,
      consulenzeRows,
      consulenzeDone,
      consulenzeTotal,
      activeConsulenzaRow,
      openConsulenzaDetail,
      closeConsulenzaDetail,
      normalizeConsulenzaStatus,
      consulenzaStatusClass,
      consulenzaTypeClass,
      hasDetachedConsulenze,
      detachedConsulenzeCount,
      isPercorsoLocked,
      isPercorsoExpired,
      isStoricoConsulenzaExpired,
      isExpireToggleBusy,
      togglePercorsoExpired,
      toggleStoricoExpired,
      updateConsulenzaField,
      updateConsulenzaDate,
      updateConsulenzaPlannedAt,
      onConsulenzaStatusChangeByKey,
      consulenzaMoveOptions,
      consulenzaMoveTarget,
      movingConsulenza,
      moveConsulenza,
      canDeleteConsulenza,
      deleteConsulenza,
      deletingConsulenza,
      deletingStoricoSlot,
      storicoSlotRowKey,
      formatDate,
      formatDateOnly,
      formatInputDate,
      updateSlotField,
      updateSlotStatus,
      normalizeSlotStatus,
      deleteStoricoConsulenzaSlot
    };
  }
};
</script>

<style scoped>

.create-consulenza-button {
  margin-bottom: 20px;
  padding: 10px 20px;
}
.modal {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(15, 23, 42, 0.45);
  backdrop-filter: blur(6px);
  z-index: 1405;
  font-family: 'Montserrat', Avenir, Helvetica, Arial, sans-serif;
}
.modal-content {
  width: min(860px, 92vw);
  max-height: calc(100vh - 48px);
  background: #ffffff;
  border-radius: 22px;
  display: flex;
  flex-direction: column;
  box-shadow: 0 32px 68px rgba(15, 23, 42, 0.22);
  overflow: hidden;
  position: relative;
  font-family: inherit;
}
.modal-content--consulenza-detail {
  width: min(860px, 92vw);
}
.modal-content button,
.modal-content input,
.modal-content select,
.modal-content textarea {
  font-family: inherit;
}
.modal-content .material-icons {
  font-family: 'Material Icons' !important;
}
.consolenze-container,
.consolenze-container h1 {
  margin-top: 20px;
}
.consulenze-container table {
  width: 99%;
  margin-bottom: 100px;
}
.consulenze-container th,
.consulenze-container td {
  padding: 10px;
  text-align: left;
  border-bottom: 1px solid #ddd;

}
.consulenze-container th:last-child,
.consulenze-container td:last-child {
  width: 78px;
  text-align: center;
}
.icon-btn {
  width: 34px;
  height: 34px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #334155;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  padding: 0;
}
.icon-btn.grey {
  color: #374151;
}
.icon-btn.danger {
  color: #991b1b;
  border-color: #fecaca;
  background: #fee2e2;
}
.icon-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}
.header-row {
  background-color: #f0f0f0;
  font-weight: bold;
}

.header-row--expired td {
  background: rgba(139, 92, 246, 0.2);
  color: #4c1d95;
}

.storico-header-content {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
}

.storico-header-title {
  font-weight: 700;
}

.storico-header-actions {
  display: inline-flex;
  align-items: center;
  gap: 10px;
}

.storico-row--expired td {
  background: rgba(139, 92, 246, 0.08);
}

/* ===== Consulenze: card / header ===== */
.consulenze-box {
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  background: #fff;
  overflow: hidden;
  max-width: 100%;
  margin-top: 14px;
}
.consulenze-box .card-head {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  background: #f9fafb;
  padding: 12px 14px;
  border: 0;
  cursor: pointer;
}
.consulenze-box .head-left {
  display: flex;
  gap: 10px;
  align-items: baseline;
  min-width: 0;
}
.consulenze-box .title { font-weight: 600; color: #111; }
.consulenze-box .sub   { font-size: .9rem; color: #6b7280; }
.consulenze-box .material-icons { font-size: 20px; line-height: 20px; color: #6b7280; }
.consulenze-box .card-body {
  padding: 12px 14px 14px;
}

.consulenze-table-wrap {
  width: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  padding-bottom: 4px;
}

.consulenze-table {
  width: 100%;
  min-width: 760px;
  border-collapse: collapse;
  background: #fff;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: inset 0 0 0 1px #e2e8f0;
}

.consulenze-table thead th {
  padding: 13px 14px;
  font-size: 0.8rem;
  font-weight: 700;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  color: #475569;
  background: #f1f5f9;
  white-space: nowrap;
}

.consulenze-table th,
.consulenze-table td {
  border-bottom: 1px solid #e5e7eb;
  padding: 14px;
  text-align: left;
  vertical-align: middle;
}
.consulenze-table tbody tr:last-child td {
  border-bottom: none;
}
.consulenze-table th:nth-child(1),
.consulenze-table td:nth-child(1) {
  width: 42%;
}
.consulenze-table th:nth-child(2),
.consulenze-table td:nth-child(2) {
  width: 13%;
}
.consulenze-table th:nth-child(3),
.consulenze-table td:nth-child(3) {
  width: 18%;
}
.consulenze-table th:nth-child(4),
.consulenze-table td:nth-child(4) {
  width: 13%;
}
.consulenze-actions-col {
  width: 120px;
}
.consulenze-table tbody tr:nth-child(odd) td {
  background: #fcfcfd;
}
.consulenze-summary-cell {
  min-width: 0;
}
.consulenze-summary-cell--program .mono {
  font-size: 0.92rem;
  line-height: 1.45;
  overflow-wrap: anywhere;
}
.consulenze-summary-cell small {
  display: block;
  margin-top: 4px;
  color: #6b7280;
}
.consulenze-status-stack {
  display: grid;
  gap: 6px;
}

.consulenze-row--locked td {
  background: #f4f4f5 !important;
  color: #6b7280;
}
.consulenze-row--expired td {
  background: rgba(139, 92, 246, 0.12) !important;
}

.consulenza-pill {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  max-width: 100%;
  padding: 6px 12px;
  border-radius: 999px;
  border: 1px solid transparent;
  font-size: 0.8rem;
  font-weight: 700;
  line-height: 1.1;
  white-space: nowrap;
}
.consulenza-pill--neutral {
  background: #f3f4f6;
  border-color: #e5e7eb;
  color: #4b5563;
}
.consulenza-pill--technical {
  background: #dbeafe;
  border-color: #bfdbfe;
  color: #1d4ed8;
}
.consulenza-pill--nutritional {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #15803d;
}
.consulenza-pill--todo {
  background: #fef3c7;
  border-color: #fde68a;
  color: #b45309;
}
.consulenza-pill--scheduled {
  background: #e0e7ff;
  border-color: #c7d2fe;
  color: #4338ca;
}
.consulenza-pill--contacted {
  background: #ede9fe;
  border-color: #ddd6fe;
  color: #6d28d9;
}
.consulenza-pill--escalated {
  background: #fce7f3;
  border-color: #fbcfe8;
  color: #9d174d;
}
.consulenza-pill--done {
  background: #dcfce7;
  border-color: #bbf7d0;
  color: #166534;
}
.consulenza-pill--rejected {
  background: #fee2e2;
  border-color: #fecaca;
  color: #b91c1c;
}

.expiry-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  padding: 2px 8px;
  font-size: 0.72rem;
  font-weight: 700;
  letter-spacing: 0.01em;
}

.expiry-badge--expired {
  background: rgba(139, 92, 246, 0.18);
  color: #6d28d9;
  border: 1px solid rgba(139, 92, 246, 0.45);
}

.consulenze-detail-btn {
  min-width: 96px;
  min-height: 40px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  background: #fff;
  color: #1f2937;
  font-weight: 600;
  cursor: pointer;
}

.modal-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
  padding: 26px 28px 16px;
  background: #f8fafc;
  border-bottom: 1px solid #e2e8f0;
}
.modal-title {
  margin: 0;
  font-size: 1.4rem;
  font-weight: 700;
  color: #0f172a;
}
.modal-title-area {
  display: grid;
  gap: 4px;
}
.modal-header-actions {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}
.consulenza-detail-subtitle {
  margin: 4px 0 0;
  color: #64748b;
  font-size: 0.92rem;
}
.consulenza-detail-body {
  padding: 22px 28px;
  overflow-y: auto;
  display: grid;
  gap: 18px;
  background: #fff;
}
.consulenza-detail-top {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 12px;
}
.consulenza-detail-summary-card {
  display: grid;
  gap: 4px;
  padding: 14px 16px;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  background: #f8fafc;
}
.consulenza-detail-summary-card strong {
  color: #0f172a;
  font-size: 0.98rem;
}
.consulenza-detail-summary-card small {
  color: #64748b;
}
.consulenza-detail-summary-label {
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #64748b;
}
.consulenza-detail-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 14px;
}
.q-field {
  display: grid;
  gap: 10px;
  padding: 18px;
  border: 1px solid #e2e8f0;
  border-radius: 16px;
  background: linear-gradient(180deg, #ffffff 0%, #f8fafc 100%);
}
.q-field--wide {
  grid-column: 1 / -1;
}
.q-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-weight: 600;
  color: #0f172a;
}
.q-field input,
.q-field textarea,
.q-field select {
  width: 100%;
  box-sizing: border-box;
  padding: 12px 14px;
  border: 1px solid #cbd5e1;
  border-radius: 12px;
  background: #ffffff;
  color: #0f172a;
  font-size: 0.95rem;
}
.consulenza-detail-note {
  min-height: 110px;
  resize: vertical;
}
.consulenza-detail-grid input[type="text"],
.consulenza-detail-grid textarea {
  color: #111827;
  -webkit-text-fill-color: #111827;
}
.consulenza-detail-grid input[type="text"]::placeholder,
.consulenza-detail-grid textarea::placeholder {
  color: #9ca3af;
  -webkit-text-fill-color: #9ca3af;
}
.consulenza-detail-move {
  display: grid;
  grid-template-columns: minmax(0, 1fr) auto;
  gap: 10px;
  align-items: center;
}
.consulenza-detail-move select {
  background: #eef2ff;
  border-color: #c7d2fe;
  color: #1f2937;
}
.consulenza-detail-move select:focus {
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.25);
  outline: none;
}
.consulenza-detail-delete {
  background: #ef4444;
  border-color: #ef4444;
}
.consulenza-detail-delete:hover:not(:disabled) {
  background: #dc2626;
}
.move-btn {
  min-width: 120px;
  min-height: 46px;
  padding: 0 18px;
  border: 1px solid #16a34a;
  background: #16a34a;
  color: #fff;
  border-radius: 10px;
  font-weight: 600;
  cursor: pointer;
}
.move-btn:hover:not(:disabled) { background:#15803d; border-color:#15803d; }
.move-btn:disabled { opacity:.7; cursor: not-allowed; }

.expire-toggle-button {
  border: 1px solid #e2e8f0;
  background: #ffffff;
  color: #475569;
  border-radius: 10px;
  padding: 6px 10px;
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 6px;
  transition: background-color 0.2s ease, border-color 0.2s ease, color 0.2s ease;
}

.expire-toggle-button .material-icons {
  font-size: 18px;
  color: inherit;
}

.expire-toggle-button:hover:not(:disabled) {
  border-color: #c4b5fd;
  background: #f5f3ff;
  color: #5b21b6;
}

.expire-toggle-button--active {
  border-color: rgba(139, 92, 246, 0.5);
  background: rgba(139, 92, 246, 0.12);
  color: #6d28d9;
}

.expire-toggle-button:disabled {
  opacity: 0.65;
  cursor: progress;
}

.link-btn {
  border: none;
  background: transparent;
  color: #2563eb;
  cursor: pointer;
  padding: 0;
  font-size: 0.85rem;
}
.link-btn:disabled {
  opacity: 0.6;
  cursor: default;
}

.date-cell {
  display: flex;
  flex-direction: column;
  gap: 2px;
  align-items: flex-start;
}
.date-cell__date {
  font-weight: 600;
  color: #111827;
}

.modal-footer {
  padding: 20px 28px;
  border-top: 1px solid #e2e8f0;
  background: #f8fafc;
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}
.modal-footer .create-user-button,
.modal-footer .action-button2 {
  min-width: 240px;
  min-height: 56px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  padding: 0 22px;
  box-sizing: border-box;
}
.modal-footer .consulenza-detail-footer-btn {
  flex: 0 0 240px;
  width: 240px;
  height: 56px;
  min-height: 56px;
  padding: 0 22px !important;
  border-radius: 12px;
  font-size: 0.95rem;
  font-weight: 600;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
}
.modal-footer .action-button2 {
  background: #ffffff;
  border: 1px solid #cbd5e1;
  color: #1e293b;
}
.modal-footer .action-button2:hover {
  border-color: #6366f1;
  color: #3730a3;
}

@media (max-width: 1024px) {
  .consulenze-table {
    min-width: 700px;
  }

  .consulenze-table th,
  .consulenze-table td {
    padding: 12px 10px;
  }

  .consulenze-table thead th {
    font-size: 0.76rem;
  }
}

@media (max-width: 860px) {
  .consulenza-detail-top,
  .consulenza-detail-grid {
    grid-template-columns: 1fr;
  }

  .consulenza-detail-move {
    grid-template-columns: 1fr;
  }

  .move-btn,
  .consulenza-detail-footer-btn {
    width: 100%;
    flex-basis: auto;
  }

  .consulenze-box .head-left {
    flex-direction: column;
    align-items: flex-start;
  }

  .modal {
    padding: 16px;
  }

  .modal-header,
  .modal-footer {
    flex-direction: column;
    align-items: stretch;
  }
}

.detached-consulenze-alert {
  display: flex;
  align-items: flex-start;
  gap: 12px;
  border: 1px solid #fdba74;
  background: #fff7ed;
  color: #9a3412;
  border-radius: 14px;
  padding: 14px 18px;
  margin-top: 14px;
  margin-right: 13px;
}
.detached-consulenze-alert .material-icons {
  font-size: 22px;
  flex-shrink: 0;
}
</style>
